import { Injectable } from "@angular/core";
import { GenetricDetailComponent } from "../components/edit-components/generic-detail.component";

@Injectable({
    providedIn: 'root'
})
export class ComponentInstancesService {
    //un map pour stocker les instances de composants
    private componentInstances = new Map<string, GenetricDetailComponent<any>>();

    //une méthode pour ajouter une instance
    public addComponentInstance(key: string, instance: GenetricDetailComponent<any>) {
        this.componentInstances.set(key, instance);
    }

    //une méthode pour obtenir une instance
    public getComponentInstance(key: string) {
        return this.componentInstances.get(key);
    }

    //une méthode pour supprimer une instance
    public removeComponentInstance(key: string) {
        this.componentInstances.delete(key);
    }

    //une méthode pour vérifier si une instance existe
    public hasComponentInstance(key: string) {
        return this.componentInstances.has(key);
    }

    //une méthode pour obtenir toutes les instances
    public getAllComponentInstances() {
        return this.componentInstances;
    }

    //une méthode pour vider le map
    public clearComponentInstances() {
        this.componentInstances.clear();
    }

    public closeAllComponents() {
        this.componentInstances.forEach((instance) => {
            instance.cancelEdit();
        });
    }
}
